module.exports = __webpack_public_path__ + "img/successful-exchange.cb816849.png";